import { useEffect } from 'react';
import { useSiteConfig } from '../selectors/global';

export function useBodyScroll(scrollClass = 'slds-scrollable--y') {
  const siteConfig = useSiteConfig();
  useEffect(() => {
    if (!siteConfig.isEmbedded) {
      return;
    }
    const body = document.getElementById('rio-body');
    if (body) {
      body.classList.add(scrollClass);
      body.style.overflowY = 'scroll';

      return () => {
        body.classList.remove(scrollClass);
        body.style.overflowY = 'hidden';
      };
    }
  }, [scrollClass, siteConfig.isEmbedded]);
}
